module.exports = __webpack_public_path__ + "static/media/21ECLAC34.b811c71c.jpg";